import model from '../models-v2/crm/crm-roles';

export default [
  {
    path: '/system-roles',
    name: 'crm-system-roles',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Role systemowe', url: '/system-roles' },
      ],
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/system-roles/edit/:id',
    name: 'system-roles-edit',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Role systemowe', url: '/system-roles' },
        { title: 'Edycja', url: '' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
  {
    path: '/system-roles/add',
    name: 'system-roles-add',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Admin', url: '' },
        { title: 'Role systemowe', url: '/system-roles' },
        { title: 'Dodawanie', url: '' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
];
